<div class="fpx-form-control">
    <fpx-label *ngIf="label" [control]="formControl" [label]="label"></fpx-label>
    <div class="fpx-field-content">
        <input matInput type="text" [attr.list]="formControlName" [(ngModel)]="selectedVal"
            value="{{selectedVal}}" autocomplete="off"
            (input)="onTypeChange($event)" (ngModelChange)="onSelectionChange($event)" #searchField/>

        <ng-container *ngIf="selectableList$ | async as selectableDataList">
            {{setInitialSelectedData(selectableDataList)}}

            <div class="rloappl-search-wrapper" id="{{formControlName}}">
                <!-- <ng-container *ngFor="let selectableData of selectableDataList"> -->
                    <div class="rloappl-search-item" *ngFor="let selectableData of selectableDataList" (click)="_rloApplicationSearchFormHelper.applyFilter($event)">{{selectableData.text}}</div>
                <!-- </ng-container> -->
            </div>
        </ng-container>

        <mat-placeholder *ngIf="placeholder" [ngClass]="{'input-available': formControl.value}" class="placeholder">
            {{ placeholder }}
        </mat-placeholder>

    </div>
    <!-- <mat-hint class="hint" *ngIf="hint" [innerHtml]="hint"></mat-hint> -->
    <mat-error *ngIf="formControl && formControl.invalid &&  formControl.touched">
        {{errorCode}}
    </mat-error>
</div>
<ng-template #defaultTemplate let-selectableData>{{ selectableData?.text }}</ng-template>